// ─── API Configuration ────────────────────────────────────────────────────────
export const API_BASE = process.env.REACT_APP_API_BASE_URL;
console.log(API_BASE)

// Core API call
export const api = async (path, opts = {}, token = null) => {
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...opts.headers,
  };
  const res = await fetch(`${API_BASE}${path}`, { ...opts, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
};

// Multipart form (file uploads)
export const apiForm = async (path, formData, token, method = "POST") => {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
};

// ─── Endpoints ────────────────────────────────────────────────────────────────
export const ENDPOINTS = {
  // Auth
  loginAdmin:       "/auth/login/admin",
  login:            "/auth/login",
  registerAdmin:    "/auth/register/admin",

  // Admin
  adminStats:       "/admin/stats",
  adminCompanies:   "/admin/companies",
  adminHackers:     "/admin/hackers",
  adminPrograms:    "/admin/programs",
  adminRanking:     "/admin/classement-hackers",
  validateKYC:      (id) => `/admin/users/${id}/docset`,
  // Vérification entreprise (statut: "en_attente" | "accepte" | "refuse")
  verifyCompany:    (id) => `/admin/companies/${id}/verify`,

  // Programs
  allPrograms:      "/programs/all",

  // Reports
  reportsByCompany: "/reports/by-company",
  reportStatus:     "/reports/status",

  // Encryption - Admin
  encKeyStatus:     "encryption/keys/status",
  encGenerate:      "/encryption/admin/generate-master-key",
  encDecryptPriv:   "/encryption/keys/decrypt-private",
  encPending:       "/encryption/admin/pending-requests",
  encRespond:       (id) => `/encryption/admin/respond/${id}`,
  encHistory:       (id) => `/encryption/admin/access-history/${id}`,
  encRequestAccess: "/encryption/admin/request-access",

  // Public
  publicRanking:    "/hackers/profil/ranking",
  publicHackers:    "/hackers/public",
};

// ─── Enums ────────────────────────────────────────────────────────────────────
export const ROLES = { SUPERADMIN: "superadmin", ADMIN: "admin" };

export const REPORT_STATUS = ["en_attente", "validé", "rejeté", "duplicate"];
export const SEVERITY = ["critique", "haute", "moyenne", "faible", "info"];
export const ACCESS_REASONS = ["litige", "fraude", "legal", "securite", "audit"];

export const CVSS_TABLE = [
  { range: "9.0 – 10.0", sev: "Critique",      pts: 100, color: "#ff4757" },
  { range: "7.0 – 8.9",  sev: "Haute",          pts: 70,  color: "#ff6b35" },
  { range: "4.0 – 6.9",  sev: "Moyenne",        pts: 40,  color: "#ffa502" },
  { range: "0.1 – 3.9",  sev: "Faible",         pts: 20,  color: "#2ed573" },
  { range: "0",          sev: "Info",            pts: 10,  color: "#00d2ff" },
  { range: "—",          sev: "Duplicate",       pts: 5,   color: "#a29bfe" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
export const cvssToSeverity = (score) => {
  if (!score) return "info";
  if (score >= 9) return "critique";
  if (score >= 7) return "haute";
  if (score >= 4) return "moyenne";
  if (score > 0) return "faible";
  return "info";
};

export const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

export const formatCurrency = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);